<template>
  <div id="contenedor-contrato-detalles">
    <template
      v-if="$apollo.loading">
      <v-skeleton-loader type="article, article, article, article">
      </v-skeleton-loader>
    </template>
    <template
      v-else>
      <span class="font-weight-bold">
        {{ contrato.numero }}
      </span>
      <p class="pa-2">
        <CortarTexto
          :texto="contrato.meta">
        </CortarTexto>
      </p>
      <div class="grey lighten-5 rounded-lg elevation-3 pa-2 mb-3">
        <span class="font-weight-bold">
          Plazo
        </span>
        <ContratoPlazo
          class="mb-2"
          :fecha-inicio="!contrato.modificado.fechaInicio
            ? contrato.fechaInicio
            : contrato.modificado.fechaInicio"
          :fecha-termino="!contrato.modificado.fechaTermino
            ? contrato.fechaTermino
            : contrato.modificado.fechaTermino"
            mostrar-ejercicio>
        </ContratoPlazo>
      </div>
      <div class="mb-2 pa-2">
        <span class="font-weight-bold mb-1">Contratista</span>
        <p>
          {{ contrato.contratista.nombreRazonSocial }}
        </p>
      </div>
      <div v-if="contrato.responsables.length >= 0" class="pa-2">
        <span class="font-weight-bold mb-1">Residente</span>
        <p>
          {{ getNombreSupervisor(contrato.responsables) }}
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import ContratoPlazo from '@/components/administracion/contratos/ContratoPlazo.vue';
import CortarTexto from '@/components/CortarTextos.vue';

export default {
  name: 'ContratoDetalles',
  components: {
    ContratoPlazo,
    CortarTexto,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return ({
          id: this.idContrato,
        });
      },
    },
  },
  methods: {
    getNombreSupervisor(responsables) {
      const supervisor = responsables.find(({ principal }) => principal === true);

      if (!supervisor) return '';

      return supervisor.funcionario.nombre;
    },
  },
};
</script>

<style lang="scss">

</style>
